module.exports = __webpack_public_path__ + "img/fc48575.png";